import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../shared/models/user.model';
import { ShellFacade } from '../shell/shell.facade';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly _http: HttpClient = inject(HttpClient);
  private readonly _shellFacade: ShellFacade = inject(ShellFacade);


  public login(email: string, password: string): Observable<void> {
    // Sanctum: erst CSRF-Cookie holen, dann login
    return this._http.get(`${environment.baseUrl}/sanctum/csrf-cookie`).pipe(
      switchMap(() => this._http.post<void>(`${environment.baseUrl}/login`, { email, password }))
    );
  }

  public logout(): Observable<void> {
    return this._http.post<void>(`${environment.baseUrl}/logout`, {});
  }

  public getProfile(): Observable<User> {
    return this._http.get<User>(`${environment.apiUrl}/user`);
  }

  public isAuthenticated(): boolean {
    return this._shellFacade.profile() != undefined;
  }
}
